import { Identifiable, Planzone, ProjectStatus } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateProjectStatus(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<ProjectStatus>, nextStatus: ProjectStatus) =>
    httpClient.sendHttpRequest<Identifiable<ProjectStatus>>({
      endpoint: `/projectStatuses/${uuid}`,
      method: HttpMethods.PATCH,
      data: nextStatus,
    });
}

export { updateProjectStatus };
